import $ from 'jquery';
import h from 'hyperscript';

import { Modal } from 'ui/dialog/modal/modal';
import 'ui/progress-spinner/progress-spinner';

import { logger } from 'cadenza/utils/logging';
import { download } from 'cadenza/utils/download';
import { handleUrlAsPopup } from 'cadenza/processes/handle-url';
import { classicPostMessage } from 'cadenza/integration/classic-post-message';
import { MIMETYPE_HTML } from 'cadenza/model/media-type';

import i18n from './process-dialog.properties';

const headers = {
  Accept: MIMETYPE_HTML
};

export function showProcessDialog (heading, processPromise) {
  const dialog = new Modal({ title: heading });
  dialog.heading = heading;
  const progress = h('d-progress-spinner', { label: i18n('process.waitText') });
  dialog.body.append(progress);

  dialog.addEventListener('cancel', event => event.preventDefault());
  dialog.addEventListener('close', () => dialog.remove());
  document.body.append(dialog);
  dialog.showModal();

  processPromise.then(({ resultAsPostMessage, noResult, url, popup } = {}) => {
    if (noResult) {
      progress.remove();
      dialog.setAlert(i18n('process.noResult.title'), i18n('process.noResult.message'), 'warning');
      dialog.footer.append(createCloseButton(dialog));
    } else if (resultAsPostMessage) {
      dialog.close();
      classicPostMessage.sendEvent(resultAsPostMessage.eventObject, {
        targetOrigin: resultAsPostMessage.targetOrigin,
        targetIFrameSelector: resultAsPostMessage.targetWindowSelector
      });
    } else if (popup) {
      dialog.close();
      handleUrlAsPopup(url, popup);
    } else if (url) {
      return handleUrl(url, dialog);
    } else {
      dialog.close();
    }
  }).catch(error => {
    logger.error('Failed to show processing result', error);
    progress.remove();
    dialog.setAlert(i18n('process.error'), error.warningMessage || error.message || i18n('common:defaultErrorMessage'));
    dialog.footer.append(createCloseButton(dialog));
  });
}

function handleUrl (url, dialog) {
  return $.ajax(url, {
    method: 'HEAD',
    headers
  }).then(function (data, textStatus, request) {
    const contentDispositionHeader = request.getResponseHeader('Content-Disposition');
    if (contentDispositionHeader && contentDispositionHeader.startsWith('attachment')) {
      return downloadAttachment(url, dialog);
    } else {
      location.href = url;
    }
  });
}

function downloadAttachment (url, dialog) {
  return download(url, {
    headers
  }).then(() => {
    dialog.close();
  });
}

function createCloseButton (dialog) {
  return h('button.button.button-primary',
    { onclick: () => dialog.close() },
    i18n('common:dialog.close.title'));
}
